import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from "../utils/utils";
import * as fromStore from '../../store';
import {DbStoreState} from '../../store';
import {Store} from '@ngrx/store';
import {User} from '../../user/user';
import {filter, switchMap} from 'rxjs/operators';

@Pipe({
    name: 'dbDate',
    standalone: false
})

export class DbDatePipe implements PipeTransform {

  private _timezoneOffset: number;

  constructor(
    private _store: Store<DbStoreState>
  ) {
    this._timezoneOffset = 0;

    this.getUserTimezone();
  }

  private getUserTimezone() {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUser))
      )
      .subscribe((user: User) => {
        this._timezoneOffset = (user && user.timeZoneOffset) ? user.timeZoneOffset : 0;
      });
  }

  transform(value: any, pattern: string = "", useTimezone = true): string | null {
    if (value) {
      value = !value.getTime ? new Date(value) : value;
      value = this.calcDateByOffset(value, useTimezone);
    }
    return Utils.formatDate(value, pattern);
  }

  private calcDateByOffset(date: Date, useTimezone): Date {
    // grdon: override angular date pipe timezone offset
    if (!useTimezone) {
      return new Date(date.getTime() + this._timezoneOffset * 1000);
    }
    const localTimezoneOffset: number = (new Date()).getTimezoneOffset() * 60 * 1000;
    return new Date(date.getTime() + this._timezoneOffset * 1000 + localTimezoneOffset);
  }

}
